import { render, staticRenderFns } from "./BetMatchList.vue?vue&type=template&id=332cd1b6&scoped=true"
import script from "./BetMatchList.vue?vue&type=script&lang=js"
export * from "./BetMatchList.vue?vue&type=script&lang=js"
import style0 from "./BetMatchList.vue?vue&type=style&index=0&id=332cd1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332cd1b6",
  null
  
)

export default component.exports